<template>
  <div>
    <img
      class="wrapper-error-img"
      :src=" src !=='undefined' ? src : poster"
      @error="handleError"
      @load="handleLoad"
      v-on="$listeners"
    />
    <i v-if="isThumb1 && loaderCLose" class="el-icon-loading icon-position"></i>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
// @group Timeline
// Timeline thumbnail
export default {
  name: "ThumbnailImage",
  props: {
    loaderCLose: {
      type: Boolean,
      default: false
    },
    isThumb: {
      type: Boolean,
      default: false
    },
    // Image source link
    src: {
      type: String,
      required: true
    },
    // Default image source link
    fallback: {
      type: String,
      default: ""
    },
    // Count of image loading attempts
    maxAttempts: {
      type: Number,
      default: 5
    }
  },
  computed: {
    ...mapGetters(["hasSudioMode"]),
    ...mapState({
      poster: state => state.services.channelPoster,
    }),
  },
  data: () => ({
    attempt: 0,
    isThumb1: true
  }),
  watch: {
    // @vuese
    // Reset attempts count if source has updated
    src() {
      this.attempt = 0;
    },
  },
  methods: {
    // @vuese
    // Set default image, if not possible to load specific for current time
    handleError(e) {
      ++this.attempt;
      console.warn(
        `Cannot load image ${e.target.src}. Attempt: ${this.attempt}`
      );
      if (this.attempt > 1000) {
        return;
      }
      if (this.hasSudioMode === "studioAudioEdit") {
        e.target.src = this.poster;
        return;
      }
      if (this.attempt < this.maxAttempts) {
        e.target.src = this.fallback;
        setTimeout(() => {
          e.target.src = this.src;
        }, 1000 * this.attempt);
      } else {
        e.target.src = this.fallback;
      }
    },
    // @vuese
    // Init attempts count
    handleLoad() {
      // this.attempt = 0;
      this.isThumb1 = false;
    }
  }
};
</script>

<style>
.icon-position {
  font-size: 25px;
  /* padding: 0 100px 0 0 ; */
  /* text-align: center; */
  /* display: flex; */
  /* justify-content: center; */
  /* margin: 0 20px 0 0 ; */
  position: relative;
  /* vertical-align: middle; */
  top: -50%;
  left: -50%;
}
.wrapper-error-img {
  width: 100%;
  height: 100%;
  position: relative;
}
</style>
